export default __webpack_public_path__ + "a43d4e32abf6302b190f1b73bf4a8bb8.svg";